// extracted by mini-css-extract-plugin
module.exports = {"footer":"PaymentMethod_footer__SW2xA","error":"PaymentMethod_error__egkez"};